import React from 'react';
import PropTypes from 'prop-types';
import { TopToolbar, ListButton } from 'react-admin';

const TagActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} record={data} />
  </TopToolbar>
);

TagActions.propTypes = {
  basePath: PropTypes.string,
  data: PropTypes.shape({}),
};

TagActions.defaultProps = {
  basePath: '',
  data: {},
};

export default TagActions;
